<template>
    <CompassDialog
        :primaryAction="{
            label: $t.__(
                'sellsyaccountmanager.SubscriptionManager.CancelSubscriptionCancellationDialog.confirmBtn',
            ),
            action: onValidate,
            loading: loading,
        }"
        :secondaryActions="[
            {
                label: $t.__('common.actions.cancel'),
                action: handleClose,
            },
        ]"
        :title="
            $t.__(
                'sellsyaccountmanager.SubscriptionManager.CancelSubscriptionCancellationDialog.title',
            )
        "
        :visible.sync="visible"
        size="small"
        @closed="handleClose"
    >
        <div class="typographies-paragraph-medium-regular">
            {{
                $t.__(
                    'sellsyaccountmanager.SubscriptionManager.CancelSubscriptionCancellationDialog.content',
                )
            }}
        </div>
    </CompassDialog>
</template>

<script>
import { cancelSubscriptionCancellation } from 'api/chargebee/chargebeeService.js';
export default {
    props: {
        subscriptionId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            visible: false,
            loading: false,
        };
    },
    mounted() {
        this.visible = true;
    },
    methods: {
        handleClose() {
            this.$emit('onClose');
        },
        onValidate() {
            this.loading = true;
            cancelSubscriptionCancellation(this.subscriptionId)
                .then(() => {
                    this.$emit('onSuccess');
                    this.$pushToast({
                        text: this.$t.__(
                            'sellsyaccountmanager.SubscriptionManager.CancelSubscriptionCancellationDialog.successToast',
                        ),
                        type: 'success',
                        icon: true,
                    });
                    this.handleClose();
                })
                .catch(() => {
                    this.$pushToast({
                        text: this.$t.__(
                            'sellsyaccountmanager.SubscriptionManager.CancelSubscriptionCancellationDialog.errorToast',
                        ),
                        type: 'error',
                        icon: true,
                    });
                    this.loading = false;
                });
        },
    },
};
</script>
